<div>
  <h5 mat-dialog-title>{{ 'createCompany' | translate }}</h5>
  <form [formGroup]="formGroup" fxLayout="column">
     <!-- Company type -->
     <mat-form-field color="accent">
      <mat-label>{{ 'typeOfClient' | translate }}</mat-label>
      <!-- <input matInput formControlName="category"> -->
      <mat-select formControlName="typeOfClient">
        <mat-option value="Verifier">{{ "verifier" | translate }}</mat-option>
        <mat-option value="Issuer">{{ "issuer" | translate }}</mat-option>
      </mat-select>
      <mat-error *ngIf="hasError('typeOfClient', 'required')">
        {{ 'requiredError' | translate }}
      </mat-error>
    </mat-form-field>
    <!-- Did -->
    <mat-form-field color="accent">
      <mat-label>{{ 'did' | translate }}</mat-label>
      <input matInput formControlName="did">
      <mat-error *ngIf="hasError('did', 'required')">
        {{ 'requiredError' | translate }}
      </mat-error>
    </mat-form-field>

    <!-- VerKey -->
    <mat-form-field color="accent">
      <mat-label>{{ 'verKey' | translate }}</mat-label>
      <input matInput formControlName="verKey">
      <mat-error *ngIf="hasError('verKey', 'required')">
        {{ 'requiredError' | translate }}
      </mat-error>
    </mat-form-field>

    <!-- Category -->
    <mat-form-field color="accent">
      <mat-label>{{ 'categories' | translate }}</mat-label>
      <!-- <input matInput formControlName="category"> -->
      <mat-select formControlName="categories" multiple>
        <mat-option *ngFor="let category of (categories$ | async)?.data" [value]="category.id">{{ category.name }}</mat-option>
      </mat-select>
    </mat-form-field>

     <!-- AgentUrl -->
    <mat-form-field color="accent">
      <input matInput placeholder="{{ 'agentUrl' | translate }}" formControlName="agentUrl">
      <mat-error *ngIf="hasError('agentUrl', 'required')">
        {{ 'requiredError' | translate }}
      </mat-error>
      <mat-error *ngIf="hasError('agentUrl', 'pattern')">
        {{ 'agentUrlNotValid' | translate }}
      </mat-error>
    </mat-form-field>

    <!-- Email -->
    <mat-form-field color="accent">
      <input matInput placeholder="{{ 'email' | translate }}" formControlName="email">
      <mat-error *ngIf="hasError('email', 'required')">
        {{ 'requiredError' | translate }}
      </mat-error>
      <mat-error *ngIf="hasError('email', 'maxlength')">
        {{ 'maxLengthError' | translate:{ value: 254 } }}
      </mat-error>
      <mat-error *ngIf="hasError('email', 'email')">
        {{ 'emailNotValid' | translate }}
      </mat-error>
    </mat-form-field>

    <!-- Phone -->
    <mat-form-field color="accent">
      <input matInput placeholder="{{ 'phone' | translate }}" formControlName="phone">
      <mat-error *ngIf="hasError('phone', 'required')">
        {{ 'requiredError' | translate }}
      </mat-error>
      <mat-error *ngIf="hasError('phone', 'maxlength')">
        {{ 'maxLengthError' | translate:{ value: 20 } }}
      </mat-error>
      <mat-error *ngIf="hasError('phone', 'pattern')">
        {{ 'phoneNotValid' | translate }}
      </mat-error>
    </mat-form-field>

    <!-- Website -->
    <mat-form-field color="accent">
      <input matInput placeholder="{{ 'website' | translate }}" formControlName="website">
      <mat-error *ngIf="hasError('website', 'required')">
        {{ 'requiredError' | translate }}
      </mat-error>
      <mat-error *ngIf="hasError('website', 'pattern')">
        {{ 'websiteNotValid' | translate }}
      </mat-error>
    </mat-form-field>

    <!-- Name translations -->
    <div formGroupName="nameTranslations">
      <span>{{ 'nameTranslations' | translate }}</span>
      <div *ngFor="let language of languages" fxLayout="column">
        <mat-form-field color="accent">
          <mat-label>{{ language.code }}</mat-label>
          <input matInput [formControlName]="language.id">
          <mat-error>
            {{ 'requiredError' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>

  <!-- Actions -->
  <div mat-dialog-actions fxLayoutAlign="end">
    <button mat-button (click)="onCancel()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button (click)="onSave()" color="accent">{{ 'save' | translate }}</button>
  </div>
</div>